import styled from 'styled-components/macro';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
export const ProductCardWrapperStyled = styled(FlexWrapper) `
  width: 100%;
`;
export const ProductCardStyled = styled(FlexWrapper) `
  height: auto;
  min-height: 124px;
  flex: 0 0 calc(50% - 12px);

  transition: height 1.3s ease-in-out, min-height 0.5s ease-in-out;

  ${ADAPTIVE.minWidth.tablet} {
    flex: 0 0 calc(33.33% - (48px / 3));
  }
`;
